<template>
  <v-data-table
    :headers="headers"
    :items="productsSelected"
    :single-expand="true"
    :expanded.sync="expanded"
    item-key="id"
    show-expand
    dense
    :items-per-page="-1"
    class="elevation-1"
  >
    <template v-slot:expanded-item="{ headers, item }">
      <td
        :colspan="headers.length"
        style="padding-top: 20px; padding-bottom: 20px"
      >
        <v-simple-table dense class="table-expanded">
          <template v-slot:default>
            <thead>
              <tr>
                <th width="240">Material</th>
                <th width="240">Cor</th>
                <th class="text-right" width="150">R$ Rede</th>
                <th class="text-right" width="150">R$ Multimarcas</th>
                <th class="text-right" width="150">R$ Novo Rede</th>
                <th class="text-right" width="150">R$ Novo Multimarcas</th>
                <th class="text-right" width="150">% Reajuste Rede</th>
                <th class="text-right" width="150">% Reajuste Multimarcas</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="attr in item.attributes" :key="attr.id">
                <td>{{ attr.material_code }} - {{ attr.material_name }}</td>
                <td>{{ attr.color_code }} - {{ attr.color_name }}</td>
                <td class="text-right">{{ item.price_cif }}</td>
                <td class="text-right">{{ item.price_mult }}</td>
                <td class="text-right">
                  <v-text-field
                    hide-details
                    outlined
                    dense
                    class="text-right"
                    @input="handleChangeNewPriceCif(item)"
                    @blur="handleBlurNewPriceCif(item)"
                    v-model.number="item.new_price_cif"
                  ></v-text-field>
                </td>
                <td class="text-right">
                  <v-text-field
                    hide-details
                    outlined
                    dense
                    class="text-right"
                    @input="handleChangeNewPriceCif(item)"
                    @blur="handleBlurNewPriceCif(item)"
                    v-model.number="item.new_price_mult"
                  ></v-text-field>
                </td>
                <td class="text-right">{{ item.percent_cif }}</td>
                <td class="text-right">{{ item.percent_mult }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </td>
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.reference="{ item }">
      {{ item.company_code }} {{ item.reference }}
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.new_price_cif="{ item }">
      <v-text-field
        hide-details
        outlined
        dense
        class="text-right"
        @input="handleChangeNewPriceCif(item)"
        @blur="handleBlurNewPriceCif(item)"
        v-model.number="item.new_price_cif"
      ></v-text-field>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.new_price_mult="{ item }">
      <v-text-field
        hide-details
        outlined
        dense
        class="text-right"
        @input="handleChangeNewPriceMult(item)"
        @blur="handleBlurNewPriceMult(item)"
        v-model.number="item.new_price_mult"
      ></v-text-field>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.percent_cif="{ item }">
      {{ item.percent_cif }}%
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.percent_mult="{ item }">
      {{ item.percent_mult }}%
    </template>
  </v-data-table>
  <!-- <v-simple-table fixed-header height="550px">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left" width="100">Referência</th>
          <th class="text-left" width="400">Produto</th>
          <th class="text-right" width="150">R$ Rede</th>
          <th class="text-right" width="150">R$ Multimarcas</th>
          <th class="text-right" width="150">R$ Novo Rede</th>
          <th class="text-right" width="150">R$ Novo Multimarcas</th>
          <th class="text-right" width="160">% Reajuste Rede</th>
          <th class="text-right" width="160">% Reajuste Multimarcas</th>
        </tr>
        <tr>
          <th class="text-left"></th>
          <th class="text-left"></th>
          <th class="text-right"></th>
          <th class="text-right"></th>
          <th class="text-right"></th>
          <th class="text-right"></th>
          <th class="text-right">
            <v-text-field
              label="% Reajuste"
              hide-details
              outlined
              dense
              reverse
              @focus="handleFocusPercentCif"
              @blur="handleBlurPercentCif"
              @input="handleChangePercentCif"
              v-model.number="percentCif"
            ></v-text-field>
          </th>
          <th class="text-right">
            <v-text-field
              label="% Reajuste"
              hide-details
              outlined
              reverse
              dense
              @focus="handleFocusPercentMult"
              @blur="handleBlurPercentMult"
              @input="handleChangePercentMult"
              v-model.number="percentMult"
            ></v-text-field>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in productsSelected" :key="item.id">
          <td>{{ item.company_code }}{{ item.reference }}</td>
          <td>{{ item.name }}</td>
          <td class="text-right">{{ item.price_cif }}</td>
          <td class="text-right">{{ item.price_mult }}</td>
          <td class="text-right">
            <v-text-field
              hide-details
              outlined
              dense
              class="text-right"
              @input="handleChangeNewPriceCif(item)"
              @blur="handleBlurNewPriceCif(item)"
              v-model.number="item.new_price_cif"
            ></v-text-field>
          </td>
          <td class="text-right">
            <v-text-field
              hide-details
              outlined
              dense
              class="text-right"
              @input="handleChangeNewPriceMult(item)"
              @blur="handleBlurNewPriceMult(item)"
              v-model.number="item.new_price_mult"
            ></v-text-field>
          </td>
          <td class="text-right">{{ item.percent_cif }}%</td>
          <td class="text-right">{{ item.percent_mult }}%</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table> -->
</template>
<script>
export default {
  props: {
    productsSelected: Array,
    handleFocusPercentMult: Function,
    handleBlurPercentMult: Function,
    handleChangePercentMult: Function,
    handleFocusPercentCif: Function,
    handleBlurPercentCif: Function,
    handleChangePercentCif: Function,
    handleChangeNewPriceCif: Function,
    handleBlurNewPriceCif: Function,
    handleChangeNewPriceMult: Function,
    handleBlurNewPriceMult: Function,
    percentCif: Number,
    percentMult: Number,
  },
  data() {
    return {
      expanded: [],
      headers: [
        { text: "Referência", value: "reference", width: 100 },
        { text: "Produto", value: "name", width: 400 },
        { text: "R$ Rede", value: "price_cif", align: "end", width: 150 },
        {
          text: "R$ Multimarcas",
          value: "price_mult",
          align: "end",
          width: 150,
        },
        {
          text: "R$ Novo Rede",
          value: "new_price_cif",
          align: "end",
          width: 150,
        },
        {
          text: "R$ Novo Multimarcas",
          value: "new_price_mult",
          align: "end",
          width: 150,
        },
        {
          text: "% Reajuste Rede",
          value: "percent_cif",
          align: "end",
          width: 150,
        },
        {
          text: "% Reajuste Multimarcas",
          value: "percent_mult",
          align: "end",
          width: 150,
        },
      ],
    };
  },
};
</script>

<style scoped>
.table-expanded {
  border: 1px solid #333 !important;
  padding-bottom: 5px !important;
  border-radius: 0px !important;
}
.table-expanded thead tr {
  background: #333 !important;
  color: white;
}
.table-expanded thead tr th {
  color: white !important;
}
.table-expanded tbody tr {
  background: #efefef !important;
}
</style>
